module.exports = "<div class=\"tool\" [class.preview]=\"previewShowen\">\n  <router-outlet></router-outlet>\n</div>\n"